<template lang="pug">
    .eachrt-bar-line(style="width:100%;height:100%;" ref="barLine")
</template>

<script>
import echarts from 'echarts'
export default {
    name: 'EchartBarLine',
    props: {
        data: {
            type: Array,
            default () {
                return []
            }
        },
        title: {
            type: String,
            default: '客流量和费用'
        }
    },
    data () {
        return {
            thisEchart: null,
            xAxisData: [],
            targetCount: [],
            cost: [],
            totalCount: [],
            matchingRate: [],
            targetCountMax: 0,
            costMax: 0,
            totalCountMax: 0,
            matchingRateMax: 0
        }
    },
    watch: {
        data () {
            this.setData()
        }
    },
    mounted () {
        this.setData()
    },
    methods: {
        setData () {
            let xAxisData = []
            let targetCount = []
            let cost = []
            let totalCount = []
            let matchingRate = []
            this.costMax = 0
            this.targetCountMax = 0
            this.totalCountMax = 0
            this.matchingRateMax = 0
            this.data.forEach((item) => {
                xAxisData.push(item.targetTime || item.peroidTime)
                targetCount.push(item.targetCount)
                cost.push(item.cost)
                totalCount.push(item.totalCount)
                matchingRate.push(item.totalCount ? (item.targetCount / item.totalCount * 100).toFixed(2) : 0)
                if (this.targetCountMax < item.targetCount) {
                    this.targetCountMax = item.targetCount
                }
                if (this.costMax < item.cost) {
                    this.costMax = item.cost
                }
                if (this.totalCountMax < item.totalCount) {
                    this.totalCountMax = item.totalCount
                }
                if (this.matchingRateMax < item.matchingRate) {
                    this.matchingRateMax = item.matchingRate
                }
            })
            this.costMax = Math.ceil((this.costMax / Math.pow(10, this.costMax.toString().length - 3))) * (Math.pow(10, this.costMax.toString().length - 3))
            this.targetCountMax = Math.ceil((this.targetCountMax / Math.pow(10, this.targetCountMax.toString().length - 2))) * (Math.pow(10, this.targetCountMax.toString().length - 2))
            this.totalCountMax = Math.ceil((this.totalCountMax / Math.pow(10, this.totalCountMax.toString().length - 2))) * (Math.pow(10, this.totalCountMax.toString().length - 2))
            this.matchingRateMax = Math.ceil((this.matchingRateMax / Math.pow(10, this.matchingRateMax.toString().length - 2))) * (Math.pow(10, this.matchingRateMax.toString().length - 2))
            if (xAxisData.length) {
                this.xAxisData = xAxisData
            } else {
                this.xAxisData = ['09:00-09:30', '09:30-10:30', '12:00-12:30', '12:30-13:00', '14:00-14:30', '18:00-18:30', '21:30-22:00']
            }
            this.targetCount = targetCount
            this.cost = cost
            this.totalCount = totalCount
            this.matchingRate = matchingRate
            this.initEcharts()
        },
        initEcharts () {
            let option = {
                title: {
                    text: this.title || '客流量和费用',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                        shadowStyle: {
                            color: 'rgba(40,39,41,0.05)'
                        }
                    },
                    // formatter: '{a0}: {c0}<br />{a1}: {c1}<br />{a2}: {c2}<br />{a3}: {c3}',
                    // formatter: '{a1}: {c1}<br />{a3}: {c3}<br />{a2}: {c2}<br />{a0}: {c0}',
                    formatter: data => {
                        console.log('formatter data:', data)
                        let colors = ['#FDCB15', '#FF3973', '#D4D4D4', '#282729']
                        return [1, 3, 2, 0].reduce( (a, b) => {
                            let item = data[b]
                            return a + `<span class="fmt-span" style="background: ${colors[b]}"></span> ${item.seriesName}: ${item.value}<br/>`
                        }, '')
                    },
                    backgroundColor: '#FFF',
                    textStyle: {
                        color: '#282729'
                    },
                    padding: 10
                },
                legend: {
                    selectedMode: false,
                    bottom: 0,
                    data: ['广告费(元)', '目标流量(人次)', '总流量(人次)', '匹配率(%)']
                },
                xAxis: [
                    {
                        type: 'category',
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: '#999999'
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#E9E9E9',
                                type: 'dashed'
                            }
                        },
                        data: this.xAxisData
                    },
                    {
                        type: 'category',
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: '#999999'
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            show: false
                        },
                        data: this.xAxisData
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '广告费用',
                        nameTextStyle: {
                            color: '#282729',
                            fontSize: '16',
                            // fontWeight: 'bold'
                        },
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: '#FF3973'
                            }
                        },
                        axisTick: {
                            lineStyle: {
                                color: '#FFF'
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#E9E9E9',
                                type: 'dashed'
                            }
                        },
                    },
                    {
                        type: 'value',
                        name: '客流量',
                        nameTextStyle: {
                            color: '#282729',
                            fontSize: '16',
                            // fontWeight: 'bold'
                        },
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: '#999999'
                            }
                        },
                        axisTick: {
                            lineStyle: {
                                color: '#FFF'
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#E9E9E9',
                                type: 'dashed'
                            }
                        }
                    },
                    {
                        type: 'value',
                        name: '匹配率',
                        show: false,
                        min: 0,
                        max: 100,
                        interval: 10,
                    }
                ],
                series: [
                    {
                        name: '匹配率(%)',
                        type: 'line',
                        data: this.matchingRate,
                        color: '#FDCB15',
                        symbolSize: '12',
                        hoverAnimation: false,
                        yAxisIndex: 2,
                        lineStyle: {
                            width: 4
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: 'rgba(255, 184, 31, 0.12)'
                                }, {
                                    offset: 1,
                                    color: 'rgba(250, 234, 97, 0.12)'
                                }]
                            }
                        }
                    },
                    {
                        name: '广告费(元)',
                        type: 'bar',
                        itemStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: '#FF846D' // 0% 处的颜色
                                }, {
                                    offset: 1, color: '#FF3973' // 100% 处的颜色
                                }]
                            },
                            barBorderRadius: [5, 5, 0, 0],

                        },
                        barWidth: 10,
                        data: this.cost
                    },
                    {
                        name: '总流量(人次)',
                        type: 'bar',
                        itemStyle: {
                            color: '#D4D4D4',
                            barBorderRadius: [5, 5, 0, 0]
                        },
                        yAxisIndex: 1,
                        barWidth: 10,
                        data: this.totalCount
                    },
                    {
                        name: '',
                        type: 'bar',
                        barWidth: 10,
                        xAxisIndex: 1,
                    },
                    {
                        name: '有效流量(人次)',
                        type: 'bar',
                        itemStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: '#504F53' // 0% 处的颜色
                                }, {
                                    offset: 1, color: '#282729' // 100% 处的颜色
                                }]
                            },
                            barBorderRadius: [5, 5, 0, 0]
                        },
                        yAxisIndex: 1,
                        barWidth: 10,
                        xAxisIndex: 1,
                        data: this.targetCount
                    }
                ]
            }
            this.thisEchart = echarts.init(this.$refs.barLine)
            this.thisEchart.setOption(option)

            window.onresize = () => {
                this.thisEchart.resize()
            }
        }
    }
}
</script>
